const translationEN = [
  {
    volume_forecast: "Volume forecast",
    dashboard: "Dashboard",
  },
];

export default translationEN;
